module.exports = __webpack_public_path__ + "static/img/deportes_02.6c30dcb1.jpeg";